import { Moon, Sun } from 'lucide-react';
import { useUIStore } from '@/stores/ui.store';

/**
 * Light/dark switch for the auth brand panel.
 *
 * The app's other two toggles live in the sidebar and the user menu, both of
 * which are post-login chrome — without this a visitor whose OS seeded the
 * theme on first load has no way to change it until they are signed in.
 * Drives the same `ui.store` action, so the choice persists into the app.
 */
export function AuthThemeToggle() {
  const theme = useUIStore((s) => s.theme);
  const toggleTheme = useUIStore((s) => s.toggleTheme);
  const isLight = theme === 'light';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isLight ? 'Switch to dark mode' : 'Switch to light mode'}
      title={isLight ? 'Dark mode' : 'Light mode'}
      className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-sidebar-text transition-colors duration-[var(--duration-fast)] hover:bg-sidebar-hover hover:text-sidebar-text-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sidebar-accent focus-visible:ring-offset-2 focus-visible:ring-offset-sidebar-bg"
    >
      {isLight ? (
        <Moon className="h-5 w-5" aria-hidden="true" />
      ) : (
        <Sun className="h-5 w-5" aria-hidden="true" />
      )}
    </button>
  );
}
